export type { InfoSectionProps } from "./info-section";
export { InfoSection } from "./info-section";
